import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  IconButton,
  Typography
} from '@mui/material';

import {
  ApartmentOutlined,
  BusinessOutlined,
  CheckCircleOutlined,
  EditOutlined,
  LanguageOutlined,
  LocationOnOutlined,
  ReceiptOutlined,
  CommentBankOutlined
} from '@mui/icons-material';
import { SvgIcon } from '@mui/material';

import {
  avatarEditButtonSx,
  cardSx,
  editButtonSx,
  infoGridSx,
  infoIconSx,
  infoItemSx,
  infoLabelSx,
  infoValueSx,
  organizationAvatarIconSx,
  organizationAvatarSx,
  organizationContentSx,
  organizationHeaderSx,
  organizationTitleSx
} from './styles';

const CompanyTaxIcon = props => (
  <SvgIcon
    {...props}
    viewBox="0 0 19 20"
  >
    <path
      d="M4.5 9H2.5V16H4.5V9ZM10.5 9H8.5V16H10.5V9ZM19 18H0V20H19V18ZM16.5 9H14.5V16H16.5V9ZM9.5 2.26L14.71 5H4.29L9.5 2.26ZM9.5 0L0 5V7H19V5L9.5 0Z"
      fill="currentColor"
    />
  </SvgIcon>
);

const InfoItem = ({ icon, label, value }) => {
  return (
    <Box sx={infoItemSx}>
      {React.cloneElement(icon, {
        sx: {
          ...infoIconSx,
          ...icon.props.sx
        }
      })}

      <Box sx={{ minWidth: 0 }}>
        <Typography sx={infoLabelSx}>
          {label}
        </Typography>

        <Typography sx={infoValueSx}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

InfoItem.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

const OrganizationInfoCard = ({
  data,
  onEdit
}) => {
  const infoItems = [
    {
      label: 'Organization Name',
      value: data.organizationName,
      icon: <BusinessOutlined />
    },
    {
      label: 'Organization Website',
      value: data.website,
      icon: <LanguageOutlined />
    },
    {
      label: 'Organization NPI',
      value: data.npi,
      icon: <CheckCircleOutlined />
    },
    {
      label: 'Billing Name',
      value: data.billingName,
      icon: <ReceiptOutlined />
    },
    {
      label: 'Company Tax ID/ Sole Proprietor SS#',
      value: data.taxId,
      icon: <CompanyTaxIcon sx={{ fontSize: 16 }} />
    },
    {
      label: 'Billing Address',
      value: data.billingAddress,
      icon: <LocationOnOutlined />
    }
  ];

  return (
    <Box sx={cardSx}>
      <Box sx={organizationContentSx}>
        <Box sx={organizationAvatarSx}>
          <ApartmentOutlined sx={organizationAvatarIconSx} />

          <IconButton
            // onClick={onEdit}
            aria-label="Edit organization logo"
            sx={avatarEditButtonSx}
            size='small'
          >
            <EditOutlined sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={organizationHeaderSx}>
            <Typography sx={organizationTitleSx}>
              Organization Info
            </Typography>

            <Button
              variant="outlined"
              size='small'
              startIcon={<EditOutlined sx={{fontSize:16}}/>}
              onClick={onEdit}
              sx={editButtonSx}
            >
              Edit
            </Button>
          </Box>

          <Box sx={infoGridSx}>
            {infoItems.map(item => (
              <InfoItem
                key={item.label}
                icon={item.icon}
                label={item.label}
                value={item.value}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

OrganizationInfoCard.propTypes = {
  data: PropTypes.shape({
    organizationName: PropTypes.string.isRequired,
    website: PropTypes.string.isRequired,
    npi: PropTypes.string.isRequired,
    billingName: PropTypes.string.isRequired,
    taxId: PropTypes.string.isRequired,
    billingAddress: PropTypes.string.isRequired
  }).isRequired,
  onEdit: PropTypes.func.isRequired
};

export default OrganizationInfoCard;